<template>
  <aside class="sidebar">
    <div
      v-for="item in items"
      :key="item.type"
      class="sidebar__wrap"
    >
      <button
        class="sidebar__item"
        :class="[
          `sidebar__item--${item.type}`,
          { 'sidebar__item--active': activePanel === item.type }
        ]"
        :title="item.label"
        @click="togglePanel(item.type)"
      >
        <span class="sidebar__icon">{{ item.icon }}</span>
      </button>

      <transition name="popover">
        <div
          v-if="activePanel === item.type"
          class="sidebar__popover"
        >
          <template v-if="item.type === 'wechat'">
            <p class="sidebar__popover-title">微信咨询</p>
            <img :src="wechatQr" alt="微信二维码" class="sidebar__qr">
            <p class="sidebar__popover-desc">扫码添加微信</p>
          </template>

          <template v-else-if="item.type === 'phone'">
            <div class="sidebar__popover-header">
              <span class="sidebar__popover-header-icon">📞</span>
              <span>电话咨询</span>
            </div>
            <a
              v-for="phone in phones"
              :key="phone"
              :href="`tel:${phone}`"
              class="sidebar__phone-row"
            >
              <span class="sidebar__phone-icon">📞</span>
              <span>{{ formatPhone(phone) }}</span>
            </a>
          </template>
        </div>
      </transition>
    </div>

    <button
      v-show="showTop"
      class="sidebar__item sidebar__top"
      title="回到顶部"
      @click="scrollTop"
    >
      <span class="sidebar__icon">↑</span>
    </button>
  </aside>
</template>

<script>
import { company } from '../data/site'
import wechatQr from '../assets/img/wx_qjq.png'

export default {
  name: 'FloatingSidebar',
  data() {
    return {
      wechatQr,
      showTop: false,
      activePanel: null,
      phones: [company.phone, company.phone2],
      items: [
        { type: 'wechat', icon: '💬', label: '微信咨询' },
        { type: 'phone', icon: '📞', label: '电话咨询' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    document.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    document.removeEventListener('click', this.onClickOutside)
  },
  methods: {
    onScroll() {
      this.showTop = window.scrollY > 400
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    togglePanel(type) {
      this.activePanel = this.activePanel === type ? null : type
    },
    onClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.activePanel = null
      }
    },
    formatPhone(phone) {
      const digits = String(phone).replace(/\D/g, '')
      if (digits.length === 11) {
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`
      }
      return phone
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar__wrap {
  position: relative;
}

.sidebar__item {
  position: relative;
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #eef1f6;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.25s;
}

.sidebar__item--wechat {
  background: #07c160;
  border-color: #07c160;
  color: #fff;
}

.sidebar__item--phone {
  background: #0052d9;
  border-color: #0052d9;
  color: #fff;
}

.sidebar__item--wechat:hover,
.sidebar__item--wechat.sidebar__item--active {
  background: #06ad56;
  border-color: #06ad56;
}

.sidebar__item--phone:hover,
.sidebar__item--phone.sidebar__item--active {
  background: #0041b8;
  border-color: #0041b8;
}

.sidebar__icon {
  font-size: 18px;
}

.sidebar__popover {
  position: absolute;
  right: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 20px;
  min-width: 180px;
  text-align: center;
}

.sidebar__popover-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.sidebar__popover-desc {
  font-size: 12px;
  color: #888;
  margin-top: 10px;
}

.sidebar__qr {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  margin: 0 auto;
  display: block;
  object-fit: cover;
}

.sidebar__popover-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  text-align: left;
}

.sidebar__popover-header-icon {
  font-size: 16px;
}

.sidebar__phone-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #f7f9fc;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: background 0.2s;
}

.sidebar__phone-row + .sidebar__phone-row {
  margin-top: 8px;
}

.sidebar__phone-row:hover {
  background: #eef3fb;
}

.sidebar__phone-icon {
  font-size: 14px;
  color: #0052d9;
}

.sidebar__top {
  background: #1a1a2e;
  color: #fff;
  border-color: #1a1a2e;
}

.sidebar__top:hover {
  background: #0052d9;
  border-color: #0052d9;
}

.popover-enter-active,
.popover-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.popover-enter,
.popover-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(8px);
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
}
</style>
